/**
 * Whether the soft keyboard is taking the bottom of the screen: a field has the focus and the
 * visual viewport is clearly shorter than the window. Only a touch screen has a soft keyboard
 * (`(pointer: coarse)`, the same test as the field-focused rules in styles.css). On a desktop the
 * visual viewport also shrinks when a trackpad pinch zooms in, and taking that for a keyboard
 * pinned the whole app to the zoomed patch, shifted down (measured 2026-10-05: a pinch to 2x with
 * a field focused set keyboard-up and moved #app down 200px), so a fine pointer never counts.
 */
export function keyboardIsUp(s: { coarse: boolean; fieldFocused: boolean; vvHeight: number; innerHeight: number }): boolean {
  return s.coarse && s.fieldFocused && s.vvHeight < s.innerHeight - 80;
}
